import { autoinject, bindingMode, InlineViewStrategy } from 'aurelia-framework';
import { bindable, ViewStrategy } from 'aurelia-templating';

import { Notification } from '~/components/notification/notification';
import { FormModel } from '~/models/form-model';
import { getAreaTemplate } from '~/utils/customisation-config-utils';
import { FetchUtils } from '~/utils/fetch-utils';
import { CustomisationConfig } from './customisation-config';

@autoinject
export class CustomisableArea {
	/**
	 * The binding context of this component. It is usually an route view model.
	 */
	public parent;

	@bindable({
		defaultBindingMode: bindingMode.toView,
		changeHandler: 'configChanged',
	})
	public config: CustomisationConfig;

	@bindable({
		defaultBindingMode: bindingMode.toView,
		changeHandler: 'areaNameChanged',
	})
	public areaName: string;

	@bindable public formModel: FormModel;
	@bindable public parentId;

	private viewStrategy?: InlineViewStrategy;

	private bind(bindingContext, overrideContext) {
		this.parent = bindingContext;
		this.onConfigChange();
	}

	private configChanged(
		newValue: CustomisationConfig,
		oldValue: CustomisationConfig,
	) {
		if (oldValue) {
			// Reset
			this.viewStrategy = undefined;
		}
		if (newValue) {
			this.onConfigChange();
		}
	}

	private onConfigChange() {
		if (!this.viewStrategy) {
			const viewStrategy = this.makeViewStrategy();
			if (viewStrategy) {
				this.viewStrategy = viewStrategy;
			}
		}
	}

	private areaNameChanged() {
		if (this.viewStrategy) {
			const viewStrategy = this.makeViewStrategy();
			if (viewStrategy) {
				this.viewStrategy = viewStrategy;
			}
		}
	}

	private makeViewStrategy(): InlineViewStrategy | undefined {
		if (this.config && this.areaName) {
			let customisationHtml: string = '';
			try {
				customisationHtml = getAreaTemplate(
					this.config.template,
					this.areaName,
				);
			} catch (e) {
				FetchUtils.logAndDisplayError(e);
				throw e;
			}
			return new InlineViewStrategy(customisationHtml);
		} else {
			return undefined;
		}
	}
}
